import { isRealLocation } from './is-real-location.js';
import { rad } from './radians.js';

const RADIUS = 6371000 // earth radius in meters
;
const { sin , cos , atan2 , sqrt , PI  } = Math;
/**
 * Calculate the geodesic distance in meters between two points on earth using
 * the haversine formula (rounded to the nearest meter). Can return Infinity if
 * either point has missing or invalid coordinates.
 */ function getDistance(start, end) {
    if (!isRealLocation(start) || !isRealLocation(end)) {
        return Infinity;
    }
    const dLat = rad(end.lat - start.lat);
    const dLon = rad(end.lon - start.lon);
    const a = sin(dLat / 2) * sin(dLat / 2) + sin(dLon / 2) * sin(dLon / 2) * cos(rad(start.lat)) * cos(rad(end.lat));
    const c = 2 * atan2(sqrt(a), sqrt(1 - a));
    return Math.round(RADIUS * c);
}

export { getDistance };
//# sourceMappingURL=get-distance.js.map
